import React, { Component } from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { Field, FieldArray, reset } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, Breadcrumb, Textarea } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { Translate, I18n } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import axios from 'axios';

import { InputField } from '../Common/inputField';
import ConfirmActionModal from '../Common/confirmActionModal';
import GenericSelection from '../Common/GenericSelection';
import PriceLevel from '../Common/priceLevel';
import Spinner from '../Widgets/spinner';
import { Selection, SelectionWithProps } from '../Common/selection';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { ROOT_URL, ROOT_API_URL, isFV } from '../../actions/root_url';
import { AgentChangeModal } from '../Common/agentChangeModal';
import { PriceTableModal } from '../Common/priceTableModal';

const isCalco = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === 'http://ctstage-scm.truckxi.com/api/';
const isHMM = ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isEcity = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_URL === 'https://ctstage-scm.truckxi.com/api/';
const isCO = ROOT_API_URL === 'https://co-scm.truckxi.com/api/' || ROOT_URL === 'https://co-scm.truckxi.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isTQ = ROOT_API_URL === 'https://topquality-scm.truckxi.com/api/'|| ROOT_URL === 'https://topquality-scm.truckxi.com/api/';
const isOCM = ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/'|| ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
const isKDW = ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
const isABCFF = ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
const isYI = ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || ROOT_URL === 'https://ying-scm.truckxi.com/api/';
const isAPO = ROOT_API_URL === 'https://apoodr-scm.truckxi.com/api/' || ROOT_URL === 'https://apoodr-scm.truckxi.com/api/';

const renderEmails = (props) => {
  const { fields } = props;
  return (
    <Row>
      <Col xs={12} className="add-bin-range-section">
        <Row>
          <Col xs={12}>
            <Button
              bsStyle="primary"
              type="button"
              onClick={() => {
                fields.push({}); // pushes empty child field onto the end of the array
              }}
            >
              <em className="fa fa-plus" />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {
              fields.map((email, index) => (
                <Row key={index} className="additional-bin-range">
                  <div className="customer-email-row">
                    <div className="customer-email-row-title" style={{ paddingLeft: '8px' }}>
                      <h4><Translate value="email" /> #{index + 1}</h4>
                    </div>
                    <div className="customer-email-row-fields">
                      <div className="customer-email-row-fields-input">
                        <div className="form-group">
                          <div className="col-xs-12">
                            <Field name={`${email}.email`} component={InputField} placeholder="Email" />
                          </div>
                        </div>
                      </div>
                      <div className="customer-email-row-fields-checkbox-section">
                        <ReactTooltip id="bypass-checkbox" place="top" type="dark" effect="solid">
                          {I18n.t('tooltip_customer_bypass_payment')}
                        </ReactTooltip>
                        <ReactTooltip id="showall-checkbox" place="top" type="dark" effect="solid">
                          {I18n.t('tooltip_customer_manager')}
                        </ReactTooltip>
                        <div className="customer-email-row-fields-checkbox">
                          <Field
                            name={`${email}.BypassPayment`}
                            component="input"
                            type="checkbox"
                          />
                          <span data-tip data-for="bypass-checkbox" >
                            {I18n.t('bypass')}
                          </span>
                        </div>
                        <div className="customer-email-row-fields-checkbox">
                          <Field
                            name={`${email}.IsManager`}
                            component="input"
                            type="checkbox"
                          />
                          <span data-tip data-for="showall-checkbox" >
                            {I18n.t('manager')}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/*
                      hiding for now since we may bring it back
                      <Col xs={ 2 }>
                        <Button
                          bsStyle="danger"
                          className="remove-btn"
                          type="button"
                          onClick={() => {
                            fields.remove(index)  // remove from index
                          } }>
                          <em className="fa fa-trash"/>
                        </Button>
                      </Col>
                    */}
                  </div>
                </Row>
              ))
            }
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const renderIsDefault = (props) => {
  // Bad implementation, cannot set the value attribute of Input componnet to a boolean.
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label');
  return (
    <div className="boolean-field">
      {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
      <label className={titleClass}><Translate value="default_address" /></label>
      <label className="boolean">
        <Input {...props.input} type="radio" value={true} checked={props.input.value === true || props.input.value === 'true'} />
        <Translate value="yes" />
      </label>
      <label className="boolean">
        <Input {...props.input} type="radio" value={false} checked={props.input.value === false || props.input.value === 'false'} />
        <Translate value="no" />
      </label>
    </div>
  );
};

const renderAfterAddonField = (props) => (
  <Input {...props.input} standalone type="text" standalone addonAfter=".00" style={{ zIndex: 0 }} />
);

const renderRadios = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label')
  return (
    <div className="boolean-field">
      {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
      {props.error && console.log(props.input.name + ' ' + props.error)}
      {props.input.name === 'IsWholesale' && <label className={titleClass} ><Translate value="wholesale" /></label>}
      {props.input.name === 'IsShowPrice' && <label className={titleClass} ><Translate value="show_price" /></label>}
      {props.input.name === 'IsActive' && <label className={titleClass} ><Translate value="active" /> <Translate value="customer" /></label>}
      {props.input.name === 'IsPrtReminder' && <label className={titleClass} ><Translate value="print_reminder" /></label>}
      {props.input.name === 'IsPrtGeneralInfor' && <label className={titleClass} ><Translate value="print_general_information" /></label>}
      <div className="boolean">
        <label>
          <Input {...props.input} type="radio" value="true" checked={props.input.value === true || props.input.value === 'true'} />
          <Translate value="yes" />
        </label>
      </div>
      <div className="boolean">
        <label>
          <Input {...props.input} type="radio" value="false" checked={props.input.value === false || props.input.value === 'false'} />
          <Translate value="no" />
        </label>
      </div>
    </div>
  );
};

// Helping function to render a multi-fields form. Reference on redux-form array.
class renderShipping extends Component {
  constructor() {
    super();
    this.state = {
      confirmOpen: false,
      agentModalOpen: false,
      ptModalOpen: false,
      drayageOptions: [],
      drayageLala: false,
    }
  }

  componentDidMount() {
    let { drayageOptions } = this.state;
    let tempName = '';
    axios
    .get(
      `${ROOT_URL}v1/product/search/?ProductCategory1_id=3`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "token"
          )}`,
        },
      },
    )
    .then(
      (res) => {
        res.data.map(r=>{
          // tempName = r.Name.replace('CLIENT DRAYAGE ', '');
          tempName = r.Name;
          drayageOptions.push({label: tempName, value: r.RefNum});
        });
        this.setState({drayageOptions});
      },
      (err) => {
        if (err.data) {
          alert(err.data);
        } else {
          alert("Server issue detected, please contact admin.");
        }
      }
    );

  }

  componentWillReceiveProps(nextProps) {
    let {drayageOptions, drayageLala} = this.state;
    if (!drayageLala) {
      this.setState({drayageOptions: []});
      setTimeout(() => {
        this.setState({drayageOptions, drayageLala: true});
      }, 800);
    }
  }

  copyBillingToShipping(e) {
    e.preventDefault();
    const shippingInfo = { ...this.props.billing, Type: 'Shipping' };
    const { shipping } = this.props;
    if (shipping && shipping.length > 0 && shipping[0]) {
      shippingInfo.CustomerDetail_id = shipping[0].CustomerDetail_id;
    } else {
      delete shippingInfo.CustomerDetail_id;
    }
    this.props.changeFieldArrayOfForm('Shipping', 0, shippingInfo, 'customerForm');
  }

  renderDeleteButton(index, fields) {
    return (
      <Button
        bsStyle="danger"
        className="trash"
        type="reset"
        onClick={() => {
          fields.remove(index);
        }}
      >
        <em className="fa fa-trash-o" />
      </Button>
    );
  }

  renderAutoFillButton() {
    return (
      <Button
        bsStyle="default"
        className="auto-fill"
        type="button"
        onClick={this.copyBillingToShipping.bind(this)}
      >
        <em className="fa fa-edit" /><Translate value="auto_fill" />
      </Button>
    );
  }

  renderAddress(Shipping, index) {
    const {drayageOptions} = this.state;
    // const drayageOptions = [
    //   {label: "LOS ANGELES", value: "LOS ANGELES"},
    //   {label: "CITY OF INDUSTRY", value: "CITY OF INDUSTRY"},
    //   {label: "SANTA FE SPRING", value: "SANTA FE SPRING"},
    //   {label: "PICO RIVERA", value: "PICO RIVERA"},
    //   {label: "WALNUT", value: "WALNUT"},
    //   {label: "DOSS-POMONA", value: "DOSS-POMONA"},
    //   {label: "POMONA", value: "POMONA"},
    //   {label: "MONTCLAIR", value: "MONTCLAIR"},
    //   {label: "CHINO", value: "CHINO"},
    //   {label: "CHINO HILLS", value: "CHINO HILLS"},
    //   {label: "EASTVALE", value: "EASTVALE"},
    //   {label: "ONTARIO-1", value: "ONTARIO-1"},
    //   {label: "ONTARIO-2", value: "ONTARIO-2"},
    //   {label: "FONTANA-1", value: "FONTANA-1"},
    //   {label: "FONTANA-2", value: "FONTANA-2"},
    //   {label: "RANCHO CUCAMANGO", value: "RANCHO CUCAMANGO"},
    //   {label: "RIVERSIDE", value: "RIVERSIDE"},
    //   {label: "SAN BERNARDINO", value: "SAN BERNARDINO"},
    //   {label: "AMAZON-ONT8", value: "AMAZON-ONT8"},
    //   {label: "AMAZON-LAX9", value: "AMAZON-LAX9"},
    //   {label: "AMAZON-LGB8", value: "AMAZON-LGB8"},
    //   {label: "ROCHA", value: "ROCHA"},
    //   {label: "IDC-WALNUT", value: "IDC-WALNUT"},
    //   {label: "IDC-BUENA PARK", value: "IDC-BUENA PARK"},
    //   {label: "IDC-LYWOOD", value: "IDC-LYWOOD"},
    //   {label: "SIGNIFY", value: "SIGNIFY"},
    //   {label: "HUBBELL", value: "HUBBELL"},
    //   {label: "TIRECO", value: "TIRECO"},
    //   {label: "UNISCO", value: "UNISCO"},
    //   {label: "GE LIGHTLING", value: "GE LIGHTLING"},
    //   {label: "FNS-FONTANA", value: "FNS-FONTANA"},
    //   {label: "FNS-SAN BERNARDINO", value: "FNS-SAN BERNARDINO"},
    //   {label: "KOHLER", value: "KOHLER"},
    //   {label: "CIC", value: "CIC"},      
    // ];

    return (
      <div>
        <Row className="form-horizontal">
          <div className="form-group">
            <label className="col-sm-2"><Translate value="name" /></label>
            <Col sm={10}>
              <Field name={`${Shipping}.AddressName`} component={InputField} />
            </Col>
          </div>
        </Row>
        <Row className="form-horizontal">
          <div className="form-group">
            <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
            <Col sm={10}>
              <Field name={`${Shipping}.Street`} component={InputField} />
            </Col>
          </div>
        </Row>
        <Row>
          <Col sm={6}>
            <div className="form-group">
              <label><Translate value="city" /><span className="asteriksReq">*</span></label>
              <Field name={`${Shipping}.City`} component={InputField} />
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <label><Translate value="state" /><span className="asteriksReq">*</span></label>
              <Field name={`${Shipping}.State`} component={InputField} />
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <label><Translate value="zip" /><span className="asteriksReq">*</span></label>
              <Field name={`${Shipping}.Zip`} component={InputField} />
            </div>
          </Col>
        </Row>

        {isMAG && 
                <Row>

          <Col sm={6}>
          <div className="form-group">
            <label><Translate value="drayage_code" /></label>
            {/* <Field name={`${Shipping}.DrayageCode`} component={InputField} /> */}
            <Field name={`${Shipping}.DrayageCode`} matchPos="any" component={Selection} options={drayageOptions} />
          </div>
        </Col>
        </Row>
         }

        <Row>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="first_name" /></label>
              <Field name={`${Shipping}.FirstName`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="last_name" /></label>
              <Field name={`${Shipping}.LastName`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="email" /></label>
              <Field name={`${Shipping}.Email`} component={InputField} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="tel" /></label>
              <Field name={`${Shipping}.Telephone`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="alt_phone" /></label>
              <Field name={`${Shipping}.Cellphone`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="fax" /></label>
              <Field name={`${Shipping}.Fax`} component={InputField} />
            </div>
          </Col>
          <Col sm={12}>
            <div className="form-group">
              <label><Translate value="note" /></label>
              <Field
                name={`${Shipping}.Note`}
                maxLength={150}
                component="Textarea"
                className="form-control"
                style={{ minHeight: '40px' }}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const fields = this.props.fields;
    return (
      <div>
        <Button
          bsStyle="primary"
          className="plus"
          type="button"
          onClick={() => { fields.push({}); }} // pushes empty child field onto the end of the array
        >
          <em className="fa fa-plus" />
        </Button>

        {!fields.length && <div className="marginTopStyle" ><Translate value="no_shipping_information" /></div>}
        {
          fields.map((Shipping, index) =>
            <Row key={index}>
              <Col sm={12}>
                <div className="position-relative">
                  <h4><Translate value="shipping_poundsign" />{index + 1}</h4>
                  {index === 0 && this.renderAutoFillButton()}
                  {this.renderDeleteButton(index, fields)}
                </div>
                {this.renderAddress(Shipping, index)}
                <Field name={`${Shipping}.IsDefault`} component={renderIsDefault} />
              </Col>
            </Row>)
        }
      </div>
    );
  }
}

class CustomerForm extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      dirty: false,
      case: 'paymentTermMissing',
      businessType: 'Restaurant',
      creditStatus: 'Good',
      IsStripe: false,
      customerOptions: [],
      rows: [],
      filters: {},
      Sub_Customer_id: "",
      fjCustomerId: "",
      customerCredit: 0,
      customerCreditModal: null,
    };
    this.openConfirm = this.openConfirm.bind(this);
    this.closeConfirm = this.closeConfirm.bind(this);
    this.openCredit = this.openCredit.bind(this);
    this.closeCredit = this.closeCredit.bind(this);
    this.openAgentModal = this.openAgentModal.bind(this);
    this.closeAgentModal = this.closeAgentModal.bind(this);
    this.openPTModal = this.openPTModal.bind(this);
    this.closePTModal = this.closePTModal.bind(this);
  }

  componentWillMount() {
    reset('customerForm');
  }

  // Deal with the preload of data.
  componentDidMount() {
    this.props.fetchCustomers()
      .then(() => {
        this.getCustomerOptions();
      })
    const { currentCustomer } = this.props;
    if (currentCustomer) {
      this.setState({fjCustomerId: currentCustomer.Customer_id});
      this.props.fetchCustomerDetail(currentCustomer.Customer_id)
        .then(() => this.props.fetchPaymentTerms());
    } else {
      this.props.fetchPaymentTerms();
      this.props.setDefaultOfForm('PriceLevel', '5', 'customerForm');
      this.props.setDefaultOfForm('IsWholesale', 'false', 'customerForm');
      this.props.setDefaultOfForm('IsShowPrice', 'true', 'customerForm');
      this.props.setDefaultOfForm('IsActive', 'true', 'customerForm');
      this.props.setDefaultOfForm('IsPrtReminder', 'false', 'customerForm');
      this.props.setDefaultOfForm('IsPrtGeneralInfor', 'false', 'customerForm');
    }
    this.props.fetchDefaultBuyers();



    if (isYI && currentCustomer) {
      axios
      .get(
        `${ROOT_URL}v1/customer/credit/balance/` + currentCustomer.Customer_id,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "token"
            )}`,
          },
        },
      )
      .then(
        (res) => {
          if (res && res.data.record) {
            if (res.data.record.length === 0) {
              this.setState({customerCredit: 0});
            } else {
              this.setState({customerCredit: res.data.record[0].total_balance});
            }
          }
          // this.setState({customerCredit: res.data});
        },
        (err) => {
          // if (err.data) {
          //   alert(err.data);
          // } else {
            // alert("Server issue detected, please contact admin. Could not fetch Credits.");
          // }
        }
      );
    }



    // making a leaving hook to confirm leaving
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dirty !== this.props.dirty) {
      this.setState({
        dirty: nextProps.dirty
      });
    }
    // if((nextProps.isActive === true || nextProps.isActive === "true") && nextProps.isActive != this.props.isActive) {
    //   if(!this.props.paymentTerm_id && !nextProps.paymentTerm_id) {
    //     this.props.setDefaultOfForm('IsActive', "false", 'customerForm');
    //     this.openConfirm();
    //   }
    // }
    if (nextProps.paymentTerm_id != this.props.paymentTerm_id) {
      if (!nextProps.paymentTerm_id || nextProps.paymentTerm_id.length === 0) {
        this.props.setDefaultOfForm('IsActive', 'true', 'customerForm');
        this.props.setDefaultOfForm('PaymentTerm_id', null, 'customerForm');
        this.openConfirm();
      }
    }
    if (nextProps.currentCustomerDetail && nextProps.currentCustomerDetail !== this.props.currentCustomerDetail) {
      const { BusinessType, CreditStatus, IsStripe } = nextProps.currentCustomerDetail;
      if (BusinessType) {
        this.setState({ businessType: BusinessType });
      }
      if (CreditStatus) {
        this.setState({ creditStatus: CreditStatus });
      }
      if (IsStripe) {
        this.setState({ IsStripe: true });
      } else {
        this.setState({ IsStripe: false });
      }
    }
    if (nextProps.currentCustomerDetail && nextProps.currentCustomerDetail !== this.props.currentCustomerDetail && nextProps.currentCustomerDetail.Sub_Customer_id) {
      this.formatCustomerInput(nextProps.currentCustomerDetail.Sub_Customer_id);
    }
  }

  componentDidUpdate() {
    reset('customerForm');
  }

  routerWillLeave(nextLocation) {
    if (this.state.dirty) return <Translate value="work_not_saved_warning" />
  }

  handleFormSubmit(formProps) {
    this.formatCustomerOutput();
    this.setState({ dirty: false });
    this.checkPermission('change_customer');
    if (!this.props.currentCustomer) {
      this.props.createCustomer(formProps, this.state);
    } else {
      if (!this.checkPermission("change_customer")) {
        this.props.editCustomer(formProps, this.state);
      } else {
        alert("You have no permission!");
      }
    }
  }

  openConfirm() {
    this.setState({ confirmOpen: true });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false });
  }

  openCredit() {
    const { customerCredit } = this.state;
    this.setState({ creditOpen: true, customerCreditModal: 0  });
  }

  closeCredit() {
    this.setState({ creditOpen: false });
  }

  onCreditChange(e) {
    this.setState({customerCreditModal: e.target.value})
  }

  saveCredit() {
    const {customerCreditModal, customerCredit} = this.state;
    const {currentCustomer} = this.props;

    let data = {
      amount: customerCreditModal,
      note: '',
    }
    axios.put(
      `${ROOT_URL}v1/customer/credit/balance/` + currentCustomer.Customer_id,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Customer Credit Changed");
      this.setState({customerCredit: Number(customerCredit) + Number(customerCreditModal), creditOpen: false});
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      } 
      alert(JSON.stringify(err.data));
    });

  }

  openAgentModal() {
    this.setState({ agentModalOpen: true });
  }
  closeAgentModal() {
    this.setState({ agentModalOpen: false });
  }

  openPTModal() {
    this.setState({ ptModalOpen: true });
  }
  closePTModal() {
    this.setState({ ptModalOpen: false });
  }

  breadcrumb() {
    if (!this.props.params.id) {
      return (
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="create_customer" />
          </Breadcrumb.Item>
        </Breadcrumb>
      );
    }
    return (
      <Breadcrumb>
        <Breadcrumb.Item>
          <Translate value="general_management" />
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Translate value="customers" />
        </Breadcrumb.Item>
        <Breadcrumb.Item active="true">
          <Translate value="edit_customer" />
        </Breadcrumb.Item>
      </Breadcrumb>
    );
  }

  renderPaymentTerms() {
    if (this.props.paymentTermsIsLoading) { return <Spinner />; } // If group is loading, show a spinner.
    let paymentTermOptions = this.getPaymentTermOptions();
    return (
      <div>
        <Field name="PaymentTerm_id" matchPos="any" component={Selection} options={paymentTermOptions} />
      </div>
    )
  }

  getPaymentTermOptions() {
    var paymentTermOptions = [];
    this.props.paymentTerms.map(paymentTerm => {
      paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name })
    });
    return paymentTermOptions;
  }

  copyBillingToMailing(e) {
    e.preventDefault();
    if (this.props.billing) {
      const mailingInfo = { ...this.props.billing, Type: 'Mailing' };
      this.props.setDefaultOfForm('Mailing', mailingInfo, 'customerForm');
    }
  }

  checkPermission(permission) {
    return false;
  }

  getDefaultBuyerOptions() {
    const salesUserOptions = [];
    (this.props.defaultBuyers || []).forEach((defaultBuyer) => {
      salesUserOptions.push({
        value: defaultBuyer.BaseUser_id,
        label: defaultBuyer.username,
      });
    });
    return salesUserOptions;
  }

  renderDefaultSales() {
    const defaultBuyerOptions = this.getDefaultBuyerOptions();
    return (
      <Field name="Sales_User_id" component={Selection} options={defaultBuyerOptions} />
    );
  }

  renderStorageFeeType() {
    const defaultBuyerOptions = [
      {label: "Pallet Count", value: "PALLET_COUNT"},
      {label: "Box CBM", value: "BOX_CBM"},
    ];
    return (
      <Field name="StorageFeeType" component={Selection} options={defaultBuyerOptions} />
    );
  }

  getCustomerOptions() {
    let customerOptions = [];
    this.props.customers.map((customer) => {
      customerOptions.push({ value: customer.Customer_id, label: customer.Name, customer_num: customer.CustomerNum });
    });
    this.setState({ customerOptions });
  }

  setCustomer = (e) => {
    let { rows } = this.state;
    let duplicate = false;
    for (let i = 0; i < rows.length; i++) {
      if (e && e.value && rows[i].customer_id === e.value) {
        duplicate = true;
        return;
      }
    }
    if (e && e.value && duplicate === false) {
      rows.push({ customer_id: e.value, customer_name: e.label, customer_num: e.customer_num });
    }
    this.setState({ rows });
  }

  removeCustomer(customer_id) {
    let { rows } = this.state;
    rows = rows.filter((obj) => {
      const match = obj.customer_id !== customer_id;
      return match;
    });
    this.setState({ rows });
  }

  formatCustomerInput(inputString) {
    let stringArray = [];
    let line = null;
    let output = [];

    stringArray = inputString.split(',');
    stringArray.map(a => {
      if (a.split(':')[1]) {
        line = { customer_id: a.split(':')[0], customer_name: a.split(':')[1].split(';')[0], customer_num: a.split(':')[1].split(';')[1] };
        output.push(line);
      }
    });
    this.setState({ rows: output });
  }

  formatCustomerOutput() {
    let { rows } = this.state;
    let outputString = "";
    if (rows && rows.length > 0) {
      rows.map(r => {
        outputString += r.customer_id + ":" + r.customer_name + ";" + r.customer_num + ",";
      });
      outputString = outputString.slice(0, -1);
    }
    this.state.Sub_Customer_id = outputString;
  }


  render() {
    const { customerOptions, customerTableData } = this.state;
    const that = this;
    const customerDetails = (<h2><Translate value="customer_details" /></h2>);
    const billingDetails = (<h2><Translate value="billing_details" /></h2>);
    const mailingDetails = (<h2><Translate value="mailing_details" /></h2>);
    const shippingDetails = (<h2><Translate value="shipping_details" /></h2>);
    const customerLink = (<h2><Translate value="customer_link" /></h2>);
    const emails = (<h2><Translate value="app_email" /></h2>);
    const confirmAction = (<Translate value="confirm_action" />);
    const agentAction = (<Translate value="agents" />);
    const creditTitle = (<Translate value="edit_credit" />);
    const priceTable = (<Translate value="customer_price_table" />);
    const { handleSubmit, submitting, pristine, isCreating, isEditing } = this.props;
    const createDialogStyle = {
      height: '600px',
      marginTop: '-20%',
      width: '680px',
      marginLeft: '-10%',
      left: '45%',
    };
    const createDialogStyle2 = {
      height: '600px',
      marginTop: '-20%',
      width: '600px',
      marginLeft: '-10%',
      left: '45%',
    };
    const creditDialogue = {
      height: '180px',
      marginTop: '-10%',
      width: '350px',
      marginLeft: '-10%',
      left: '55%',
    };
    const createDialogStylePT = {
      height: '600px',
      marginTop: '-20%',
      width: '600px',
      marginLeft: '-10%',
      left: '45%',
    };
    const businessTypeOptions = isHMM ? [
      { label: 'WHOLESALER', value: 'WHOLESALER' },
      { label: 'BUILDER', value: 'BUILDER' },
      { label: 'CONTRACTOR', value: 'CONTRACTOR' },
      { label: 'RETAILER', value: 'RETAILER' },
      { label: 'CUSTOMER', value: 'CUSTOMER' },
    ] : isFJ ? [
      { label: 'Freight Broker', value: 'Freight Broker' },
      { label: 'Freight Forwarder', value: 'Freight Forwarder' },
      { label: 'Direct Customer', value: 'Direct Customer' },
      { label: 'Warehouse', value: 'Warehouse' },
      { label: 'Consolidator', value: 'Consolidator' },
    ] : isTQ ? [
      { label: 'Retail', value: 'Retail' },
      { label: 'Tenant', value: 'Tenant' },
      { label: 'Wholesale', value: 'Wholesale' },
      { label: 'Service', value: 'Service' },
    ] : isWIZ ? [
      { label: 'Customer', value: 'Customer' },
      { label: 'Agent', value: 'Agent' },
    ] : isFV ? [
      { label: 'Restaurant', value: 'Restaurant' },
      { label: 'Warehouse', value: 'Warehouse' },
      { label: 'Market', value: 'Market' },
    ] : isAPO ? [
      { label: 'Contractor', value: 'Contractor' },
      { label: 'Retailer', value: 'Retailer' },
      { label: 'Distributor', value: 'Distributor' },
      { label: 'Wholesale', value: 'Wholesale' },
    ] : [
      { label: 'Restaurant', value: 'Restaurant' },
      { label: 'Warehouse', value: 'Warehouse' },
      { label: 'Tour Group', value: 'Tour Group' },
      { label: 'Hotel', value: 'Hotel' },
    ]
    
    const creditOptions = [
      { label: 'Good', value: 'Good' },
      { label: 'Bad', value: 'Bad' },
      { label: 'COD', value: 'COD' },
    ];

    const paymentMethodOptions = [
      { label: 'Anywhere', value: false },
      { label: 'Stripe', value: true },
    ];

    const delFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => {
                // const ProductNum = this.props.dependentValues.ProductNum;
                const Index = this.props.dependentValues.customer_id;
                that.removeCustomer(Index);
              }}
            >X
              </Button>
          </span>
        );
      },
    });

    const columns = [
      {
        name: <Translate value="del" />,
        width: 50,
        formatter: delFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'customer_name',
        name: <Translate value="customer_name" />,
        width: 200,
        resizable: false,
        sortable: true,
        filterable: true,
      },
      {
        key: 'customer_num',
        name: <Translate value="customer_num" />,
        width: 160,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];

    const getRows = () => Data.Selectors.getRows(this.state);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };
    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    };
    const onClearFilters = () => {
      this.setState({ filters: {} });
    };
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    if (this.props.detailIsLoading && !this.props.detailError) {
      return (
        <ContentWrapper><br />...<Translate value="reading_data" /></ContentWrapper>
      );
    } else if (this.props.detailError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
        </ContentWrapper>
      );
    }

    const {
      currentCustomer
    } = this.props;
    const token = localStorage.getItem('token');

    const memberCardURL = `${ROOT_URL}v1/customer/print_member/${currentCustomer && currentCustomer.Customer_id}?Bearer=${token}`;

    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
          {/* Nav Trail */}
          {this.breadcrumb()}
          {/* Breadcrumb Buttons */}
          <ButtonToolbar>
          {
            isFJ &&
            <Button
              bsStyle="success"
              type="button"
              onClick={() => this.openAgentModal()}
              disabled={this.context.router.routes[1].path === 'customers/new'}
            >
              <em className="fa fa-pencil" /><Translate value="agents" />
            </Button>
          }
          {
            (isWIZ || isMAG || isKDW || isABCFF) &&
            <Button
              bsStyle="success"
              type="button"
              onClick={() => this.openPTModal()}
              disabled={this.context.router.routes[1].path === 'customers/new'}
            >
              <em className="fa fa-pencil" /><Translate value="price_table" />
            </Button>
          }
            <Button
              bsStyle="success"
              type="button"
              onClick={handleSubmit(this.handleFormSubmit.bind(this))}
              disabled={submitting || isEditing || isCreating}
            >
              <em className="fa fa-save" /><Translate value="save" />
            </Button>
            <Button
              bsStyle="danger"
              type="reset"
              onClick={() => window.history.back()}
            >
              <em className="fa fa-close" /><Translate value="cancel" />
            </Button>
          </ButtonToolbar> {/* End Breadcrumb Buttons */}
          <Grid id="customer-form">
            {/* Row Wrapper */}
            <Row>
              {/* Customer Details */}
              <Col sm={8}>
                <Panel id="customer-details" header={customerDetails} style={{height: (isKDW || isABCFF) ? '430px' : '395px'}}>
                  {/* <h3><Translate value="general_information" /></h3> */}
                  <Row>
                    <Col sm={8}>
                      <div className="form-group">
                        <label><Translate value="name" /><span className="asteriksReq">*</span></label>
                        <Field name="Name" component={InputField} />
                      </div>
                      <div className="form-group description-business-type-form-group">
                        <div className="description-input-field">
                          <label htmlFor="description"><Translate value="description" /></label>
                          <Field name="Description" component={InputField} className="inputFieldStyle" />
                        </div>
                        <div className="business-type-form-group">
                          <label htmlFor="business-type"><Translate value="business_type" /></label>
                          <GenericSelection
                            options={businessTypeOptions}
                            value={this.state.businessType}
                            setSelected={(e) => { this.setState({ businessType: e.value }); }}
                          />
                        </div>
                        {
                          isYI && 
                          <div style={{marginLeft: '10px'}}>
                          <label ><Translate value="credit_amount" /></label>
                          <input type="text" value={this.state.customerCredit} disabled={true} onChange={(e) => console.log(e)} style={{ border: '1px solid black', height: '30px', borderRadius: '4px', margin: '0', padding: '10px' }} />
                          <Button
                            bsStyle="primary"
                            type="button"
                            style={{marginLeft: '2px'}}
                            disabled={!currentCustomer}
                            onClick={() => this.openCredit()}
                          >
                            <em className="fa fa-edit" />
                            {/* <Translate value="auto_fill" /> */}
                        </Button>
                        </div>
                        }
                        {isCalco &&
                          <div className="business-type-form-group">
                            <label htmlFor="business-type"><Translate value="payment_method" /></label>
                            <GenericSelection
                              options={paymentMethodOptions}
                              value={this.state.IsStripe}
                              setSelected={(e) => { this.setState({ IsStripe: e.value }); }}
                            />
                          </div>
                        }
                      </div>
                    </Col>
                    <Col sm={4}>
                      {/* <h3><Translate value="payment_information" /></h3> */}
                      <div className="form-group">
                        <label><Translate value="payment_term" /><span className="asteriksReq">*</span></label>
                        {this.renderPaymentTerms()}
                      </div>
                      <Row>
                        <Col sm={6}>
                          <div className="form-group">
                            <label><Translate value="credit_limit" /></label>
                            <Field name="CreditLimit" component={renderAfterAddonField} standalone type="text" standalone addonAfter=".00" />
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="credit-type-form-group">
                            <label htmlFor="credit-type"><Translate value="credit_status" /></label>
                            <GenericSelection
                              options={creditOptions}
                              value={this.state.creditStatus}
                              setSelected={(e) => { this.setState({ creditStatus: e.value }); }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={7}>
                      <Row>
                        <Col sm={3}>
                          <div className="form-group">
                            <label><Translate value="cust_no" /><span className="asteriksReq">*</span></label>
                            <Field name="CustomerNum" component={InputField} />
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="form-group">
                            <label><Translate value="ref_num" /></label>
                            <Field name="RefNum" component={InputField} />
                          </div>
                        </Col>
                        <Col sm={6} className="no-padding">
                          <Field name="PriceLevel" component={PriceLevel} isRequired={true} />
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>
                          <div className="form-group">
                            <label><Translate value="ein" /></label>
                            <Field name="EIN" component={InputField} />
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="form-group">
                            <label><Translate value="driver_license" /></label>
                            <Field name="DLN" component={InputField} />
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="form-group">
                            <label><Translate value="reseller" /></label>
                            <Field name="Reseller" component={InputField} />
                          </div>
                        </Col>
                      </Row>
                      {
                        isEcity &&
                        <Row>
                          <Col sm={4}>
                            <div className="form-group">
                              <label><Translate value="member_card" /></label>
                              <Field name="MemberCard" component={InputField} disabled />
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="form-group">
                              <label><Translate value="member_card_download" /></label>
                              <Button
                                bsStyle="success"
                                type="button"
                                href={memberCardURL}
                              // disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1}
                              >
                                <em className="fa fa-download" /><Translate value="member_card" />
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      }
                    </Col>
                    <Col sm={3}>
                      <Field name="IsWholesale" component={renderRadios} />
                      <Row className="form-horizontal">
                        <div className="form-group">
                          <label className="col-sm-6"><Translate value="resale_no" /></label>
                          <div className="col-sm-6">
                            <Field name="Wholesale_ResaleNo" component={InputField} />
                          </div>
                        </div>
                      </Row>
                      {
                        isCO && <Row className="form-horizontal">
                          <div className="form-group">
                            <label className="col-sm-6"><Translate value="customer_discount" /></label>
                            <div className="col-sm-6">
                              <Field name="DiscountPercentage" component={InputField} />
                            </div>
                          </div>
                        </Row>
                      }
                      <Field name="IsShowPrice" component={renderRadios} />
                      <Field name="IsActive" component={renderRadios} paymentTerm_id={this.props.paymentTerm_id} setDefaultOfForm={this.props.setDefaultOfForm} />
                    </Col>
                    <Col sm={isABCFF ? 3 : 6}>
                      <div className="form-group">
                        <label><Translate value="note" /></label>
                        <Field name="Notation" maxLength={150} component={InputField} />
                      </div>
                    </Col>

{
  isABCFF &&
                    <Col sm={3}>
                      <div className="form-group">
                        <label><Translate value="storage_fee_type" /></label>
                        {this.renderStorageFeeType()}
                   </div>
                    </Col>
  }

                    <Col sm={(isKDW || isABCFF) ? 3 : 6}>
                      <div className="form-group">
                        <label><Translate value="default_sales" /></label>
                        {this.renderDefaultSales()}
                      </div>
                    </Col>
{
  (isKDW || isABCFF) &&
                    <Col sm={3}>
                          <div className="form-group">
                            <label><Translate value="storage_free_days" /></label>
                            <Field name="StorageFreeDays" component={InputField} />
                          </div>
                        </Col>
  }
                  </Row>

{
  (isKDW || isABCFF) &&
<Row>
<Col sm={6}>
<div className="form-group">
                        <label><Translate value="finance_email_list" /></label>
                        <span style={{color: 'red', marginLeft: '5px'}}>Press Enter for more emails</span>
                        <Field name="FinanceEmail" component="Textarea" className="form-control" style={{ minHeight: '50px' }}/>
                      </div>

</Col>
<Col sm={6}>
<div className="form-group">
                        <label><Translate value="operation_email_list" /></label>
                        <span style={{color: 'red', marginLeft: '5px'}}>Press Enter for more emails</span>
                        <Field name="OperationEmail" component="Textarea" className="form-control" style={{ minHeight: '50px' }}/>
                      </div>
</Col>
</Row>
  }


{
  (isYI) &&
<Row>
<Col sm={6}>
<div className="form-group">
                        <label><Translate value="percentage_fee" />(%)</label>
                        <Field name="FlatMarkup" component={InputField} />
                      </div>

</Col>
<Col sm={6}>
<div className="form-group">
                        <label><Translate value="flat_fee" />($)</label>
                        <Field name="PctMarkup" component={InputField} />
                      </div>
</Col>
</Row>
  }

                </Panel>
              </Col>
              {/* End Customer Details */}
              {/* Emails */}
              <Col sm={4}>
                <Panel id="e-mails" header={emails}>
                  <Row>
                    <FieldArray name="email" component={renderEmails} />
                  </Row>
                </Panel>
              </Col>
              {/* End Emails */}
            </Row>
            <Row>
              {/* Billing Details */}
              <Col sm={4}>
                <Panel id="billing-details" header={billingDetails}>
                  {/* <h3><Translate value="billing_address" /></h3> */}
                  <Row className="form-horizontal">
                    <div className="form-group">
                      <label className="col-sm-2"><Translate value="name" /></label>
                      <div className="col-sm-10">
                        <Field name="Billing.AddressName" component={InputField} />
                      </div>
                    </div>
                  </Row>
                  <Row className="form-horizontal">
                    <div className="form-group">
                      <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
                      <div className="col-sm-10">
                        <Field name="Billing.Street" component={InputField} />
                      </div>
                    </div>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <div className="form-group">
                        <label><Translate value="city" /><span className="asteriksReq">*</span></label>
                        <Field name="Billing.City" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="form-group">
                        <label><Translate value="state" /><span className="asteriksReq">*</span></label>
                        <Field name="Billing.State" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="form-group">
                        <label><Translate value="zip" /><span className="asteriksReq">*</span></label>
                        <Field name="Billing.Zip" component={InputField} />
                      </div>
                    </Col>
                  </Row>

                  {/* <h3><Translate value="billing_contact" /></h3> */}
                  <Row>
                    <Col sm={(isTQ||isOCM) ? 6 : 4}>
                      <div className="form-group">
                        <label><Translate value="first_name" /></label>
                        <Field name="Billing.FirstName" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={(isTQ||isOCM) ? 6 : 4}>
                      <div className="form-group">
                        <label><Translate value="last_name" /></label>
                        <Field name="Billing.LastName" component={InputField} />
                      </div>
                    </Col>
                    {
                      !(isTQ||isOCM || isMAG) && 
                      <Col sm={4}>
                        <div className="form-group">
                          <label><Translate value="email" /></label>
                          <Field name="Billing.Email" component={InputField} maxLength={200}/>
                        </div>
                      </Col> 
                    }
                  </Row>
                  <Row>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="tel" /><span className="asteriksReq">*</span></label>
                        <Field name="Billing.Telephone" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="alt_phone" /></label>
                        <Field name="Billing.Cellphone" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="fax" /></label>
                        <Field name="Billing.Fax" component={InputField} />
                      </div>
                    </Col>
                  </Row>
                  {
                    (isTQ||isOCM || isMAG) &&
                    <Row>
                      <Col sm={12}>
                        <div className="form-group">
                          <label><Translate value="email" /></label>
                          <span className="asteriksReq"><Translate value="press_enter_for_emails" /></span>
                          <Field
                            name="Billing.Email"
                            component="Textarea"
                            className="form-control resize-vertical"
                            style={{ minHeight: '40px' }}
                            resize="vertical"
                          />
                        </div>
                      </Col>
                    </Row>
                  }
                </Panel>
              </Col>
              {/* End Billing Details */}
              {/* Mailing Details */}
              <Col sm={4}>
                <Panel id="mailing-details" header={mailingDetails}>
                  {/* <h3><Translate value="mailing_address" /></h3> */}
                  <Row className="form-horizontal">
                    <div className="form-group">
                      <label className="col-sm-2"><Translate value="name" /></label>
                      <Col sm={6}>
                        <Field name="Mailing.AddressName" component={InputField} />
                      </Col>
                      <Col sm={4}>
                        <Button
                          bsStyle="default"
                          className="auto-fill"
                          type="button"
                          onClick={this.copyBillingToMailing.bind(this)}
                        >
                          <em className="fa fa-edit" /><Translate value="auto_fill" />
                        </Button>
                      </Col>
                    </div>
                  </Row>
                  <Row className="form-horizontal">
                    <div className="form-group">
                      <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
                      <Col sm={10}>
                        <Field name="Mailing.Street" component={InputField} />
                      </Col>
                    </div>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <div className="form-group">
                        <label><Translate value="city" /><span className="asteriksReq">*</span></label>
                        <Field name="Mailing.City" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="form-group">
                        <label><Translate value="state" /><span className="asteriksReq">*</span></label>
                        <Field name="Mailing.State" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="form-group">
                        <label><Translate value="zip" /><span className="asteriksReq">*</span></label>
                        <Field name="Mailing.Zip" component={InputField} />
                      </div>
                    </Col>
                  </Row>

                  {/* <h3><Translate value="contact_information" /></h3> */}
                  <Row>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="first_name" /></label>
                        <Field name="Mailing.FirstName" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="last_name" /></label>
                        <Field name="Mailing.LastName" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="email" /></label>
                        <Field name="Mailing.Email" component={InputField} />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="tel" /></label>
                        <Field name="Mailing.Telephone" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="alt_phone" /></label>
                        <Field name="Mailing.Cellphone" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="fax" /></label>
                        <Field name="Mailing.Fax" component={InputField} />
                      </div>
                    </Col>
                  </Row>
                </Panel>
              </Col>
              {/* End Mailing Details */}
              {/* Shipping Details */}
              <Col sm={4}>
                <Panel id="shipping-details" header={shippingDetails}>
                  <h3><Translate value="shipping_address" /></h3>
                  <FieldArray
                    name="Shipping"
                    component={renderShipping}
                    billing={this.props.billing}
                    shipping={this.props.shipping} // {this.props.billingAddress}
                    changeFieldArrayOfForm={this.props.changeFieldArrayOfForm}
                  />
                </Panel>
              </Col>
              {/* End Shipping Details */}
            </Row>
            {/* End Row Wrapper */}
            {
              (isAFG || isEcity) &&
              <Row>
                <Col sm={4}>
                  <Panel id="customer-link" header={customerLink}>
                    <div>
                      <Field
                        name="receivingCustomer"
                        matchPos="any"
                        placeholder={
                          <span>
                            <Translate value="customer" />
                            <span className="asteriksReq" >*</span>
                          </span>
                        }
                        onSelect={e => this.setCustomer(e)}
                        component={SelectionWithProps}
                        options={customerOptions}
                      />
                    </div>
                    <div className="react-customizer" id="customer-dataGrid3">
                      <ReactDataGrid
                        rowKey="customer_id"
                        columns={columns}
                        rowHeight={25}
                        headerRowHeight={45}
                        minHeight={175}
                        rowGetter={rowGetter}
                        rowsCount={getSize()}
                        toolbar={<Toolbar enableFilter />}
                        onAddFilter={handleFilterChange}
                        onClearFilters={onClearFilters}
                        onGridSort={handleGridSort}
                      />
                    </div>
                  </Panel>
                </Col>
              </Row>
            }
            {this.props.isCreating || this.props.isEditing && <Spinner />}
            {/* this.props.createError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.createError)}</div> */}
            {/* this.props.editError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.editError)}</div> */}
          </Grid>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm() }} title={confirmAction}>
            <ConfirmActionModal case={this.state.case} closeC={this.closeConfirm} />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle2} isVisible={this.state.agentModalOpen} onCloseClicked={() => { this.closeAgentModal() }} title={agentAction}>
            <AgentChangeModal
              fjCustomerId = {this.state.fjCustomerId}
              fetchFJAgents = {this.props.fetchFJAgents}
              updateFJAgents = {this.props.updateFJAgents}
              deleteFJAgents = {this.props.deleteFJAgents}
              closeAgentModal = {this.closeAgentModal}
              // salesOrderId={singleSalesOrderId}
              // fetchShippingWeightTracking={this.props.fetchShippingWeightTracking}
              // finalShippingWeight={this.state.finalShippingWeight}
              // onSave={this.onChangeWeightSubmit}
              // onSavePrint={this.onChangeWeightSubmitPrint}
              // onChange={this.onShippingWeightChange}
            />
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={creditDialogue} isVisible={this.state.creditOpen} onCloseClicked={() => { this.closeCredit() }} title={creditTitle}>
           

          <div>
          <Row className="centerStyle">
          <label ><Translate value="add_credit_amount" />:&nbsp;</label>



        <input type="number" value={this.state.customerCreditModal} disabled={false} onChange={(e) => this.onCreditChange(e)} style={{ border: '1px solid black', height: '30px', borderRadius: '4px', margin: '0', padding: '10px' }} />
                         
        </Row>
          <Row className="centerStyle" style={{marginTop: '10px'}}>
          <Button
                            bsStyle="primary"
                            type="button"
                            style={{marginLeft: '0px'}}
                            onClick={() => this.saveCredit()}
                          >
                            {/* <em className="fa fa-edit" /> */}
                            <Translate value="confirm" />
                        </Button>
                        <Button
                            bsStyle="danger"
                            type="button"
                            style={{marginLeft: '10px'}}
                            onClick={() => this.closeCredit()}
                          >
                            {/* <em className="fa fa-edit" /> */}
                            <Translate value="cancel" />
                        </Button>
        </Row>


                        </div>

          </SkyLightStateless>

          <SkyLightStateless dialogStyles={createDialogStylePT} isVisible={this.state.ptModalOpen} onCloseClicked={() => { this.closePTModal() }} title={priceTable}>
          <PriceTableModal
              fjCustomerId = {this.state.fjCustomerId}
              fetchPT = {this.props.fetchPT}
              updatePT = {this.props.updatePT}
              // deleteFJAgents = {this.props.deleteFJAgents}
              closePTModal = {this.closePTModal}
            />
          </SkyLightStateless>
        </form>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default withRouter(CustomerForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Customers/customerForm.jsx